import { createSelector } from '@reduxjs/toolkit';
import { LocationGroupsListState } from 'ducks/location-groups-list/slices';
import { RootState } from 'store';

const locationGroupsListSlice = (state: RootState) => state.location_groups_list;

export const selectLocationGroupsList = createSelector(
  [locationGroupsListSlice],
  (state): LocationGroupsListState => state,
);
